import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import routes from 'app/routes';
import { useContext as useUsersContext } from 'components/Users/Context';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import Home from './Home';
import { useContext } from './Context';
import PolicyPlansNew from './Plans/New/Index';
import ChoosePolicyTemplate from './Plans/New/ChoosePolicyTemplate';
import CompanyInformation from './Plans/New/CompanyInformation';
import PlanDetails from './Plans/New/PlanDetails';
import Services from './Plans/New/Services';
import Summary from './Plans/New/Summary';
import Success from './Plans/New/Success';
import Show from './Plans/Show/Index';
import Activated from './Plans/Show/Activated';
import PolicyPlansEdit from './Plans/Edit/Index';
import PlanDetailsEdit from './Plans/Edit/PlanDetails';
import ServicesEdit from './Plans/Edit/Services';
import SummaryEdit from './Plans/Edit/Summary';
import SuccessEdit from './Plans/Edit/Success';

export default function Main({ enterpriseId, policyEnabled }) {
  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();
  const { dispatch: dispatchPlans, actions: actionsPlans, state: statePlans } = useContext();

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
    actionsPlans.load(dispatchPlans);
    actionsPlans.loadEnterprise(dispatchPlans, enterpriseId);
  }, []);

  if (statePlans.plans === null || statePlans.enterprise === null) {
    return (
      <div className="content">
        <section>
          <LoadingPlaceholder text="Loading..." className="my-4" />
        </section>
      </div>
    );
  }

  const router = createBrowserRouter([
    {
      path: routes.managers.policy.index,
      element: <Home enterpriseId={enterpriseId} policyEnabled={policyEnabled} />,
    },
    {
      element: <PolicyPlansNew />,
      children: [
        {
          path: `${routes.managers.plans.new.choose_template}`,
          element: <ChoosePolicyTemplate />,
        },
        {
          path: `${routes.managers.plans.new.company}`,
          element: <CompanyInformation />,
        },
        {
          path: `${routes.managers.plans.new.plan_details}`,
          element: <PlanDetails enterpriseId={enterpriseId} />,
        },
        {
          path: `${routes.managers.plans.new.services}`,
          element: <Services />,
        },
        {
          path: `${routes.managers.plans.new.summary}`,
          element: <Summary />,
        },
        {
          path: `${routes.managers.plans.new.success}`,
          element: <Success />,
        },
      ],
    },
    {
      path: `${routes.managers.plans.show()}`,
      element: <Show enterpriseId={enterpriseId} />,
    },
    {
      path: `${routes.managers.plans.activated()}`,
      element: <Activated />,
    },
    {
      element: <PolicyPlansEdit />,
      children: [
        {
          path: `${routes.managers.plans.edit.plan_details()}`,
          element: <PlanDetailsEdit enterpriseId={enterpriseId} />,
        },
        {
          path: `${routes.managers.plans.edit.services()}`,
          element: <ServicesEdit enterpriseId={enterpriseId} />,
        },
        {
          path: `${routes.managers.plans.edit.summary()}`,
          element: <SummaryEdit enterpriseId={enterpriseId} />,
        },
        {
          path: `${routes.managers.plans.edit.success()}`,
          element: <SuccessEdit />,
        },
      ],
    },
  ]);

  return (
    <RouterProvider router={router} />
  );
}

Main.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
  policyEnabled: PropTypes.bool,
};

Main.defaultProps = {
  policyEnabled: true,
};
